import { eventDispatcher, TOPICS } from '@origin-digital/event-dispatcher';
import { SAC_XHR_LOAD_ERROR, XHR_LOAD_ERROR } from '../constants';

var dispatchErrorEvent = function dispatchErrorEvent() {
  if (eventDispatcher) {
    eventDispatcher.dispatch({
      payload: {
        message: XHR_LOAD_ERROR,
        type: 'error',
        uniqueId: SAC_XHR_LOAD_ERROR
      },
      topic: TOPICS.ALERT_BANNER_OPEN
    });
  }
};

var dispatchNoErrorEvent = function dispatchNoErrorEvent() {
  if (eventDispatcher) {
    eventDispatcher.dispatch({
      payload: {
        uniqueId: SAC_XHR_LOAD_ERROR
      },
      topic: TOPICS.ALERT_BANNER_CLOSE
    });
  }
};

export { dispatchErrorEvent, dispatchNoErrorEvent };